/**
 * The documents index lists one row per stored side. A slot shows files: the sides of one upload
 * share a lineage (and its live version), so they are one file, with Replace and Remove acting
 * on both. Newest file first.
 */
export function groupDocumentsIntoFiles(documents) {
  const files = {};

  (Array.isArray(documents) ? documents : []).forEach((document) => {
    const key = document.lineage_id ?? `document-${document.id}`;

    files[key] ||= {
      key,
      id: document.id,
      slot: document.slot,
      kind: document.kind,
      holder: document.holder,
      holder_name: document.holder_name,
      version: document.version,
      created_at: document.created_at,
      expires_at: document.expires_at,
      sides: {},
    };
    files[key].sides[document.side || 'front'] = document;
  });

  return Object.values(files).sort((a, b) => String(b.created_at).localeCompare(String(a.created_at)));
}

/** The files of each slot, keyed by slot; documents in no slot are left out. */
export function filesBySlot(documents) {
  return groupDocumentsIntoFiles(documents).reduce((slots, file) => {
    if (file.slot) {
      (slots[file.slot] ||= []).push(file);
    }

    return slots;
  }, {});
}

/** How many required slots still miss a document. */
export function countMissingSlots(slots) {
  return (Array.isArray(slots) ? slots : []).filter((slot) => slot.is_missing).length;
}
